var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconProductHostingMeet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    clipPath: "url(#clip0_2881_52775)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21 41.8431C32.598 41.8431 42 32.4762 42 20.9215C42 9.36689 32.598 0 21 0C9.40202 0 0 9.36689 0 20.9215C0 32.4762 9.40202 41.8431 21 41.8431Z",
    fill: "url(#paint0_linear_2881_52775)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.5092 17.2896H9.86422C9.15172 17.2896 8.57422 16.7142 8.57422 16.0044V9.30204C8.57422 7.59096 9.96922 6.20117 11.6867 6.20117C13.4042 6.20117 14.7992 7.59096 14.7992 9.30204V16.0044C14.7992 16.7142 14.2217 17.2896 13.5092 17.2896Z",
    fill: "url(#paint1_linear_2881_52775)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.5092 17.2896H9.86422C9.15172 17.2896 8.57422 16.7142 8.57422 16.0044V9.30204C8.57422 7.59096 9.96922 6.20117 11.6867 6.20117C13.4042 6.20117 14.7992 7.59096 14.7992 9.30204V16.0044C14.7992 16.7142 14.2217 17.2896 13.5092 17.2896Z",
    fill: "url(#paint2_linear_2881_52775)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M17.8877 17.2896H21.5327C22.2452 17.2896 22.8227 16.7142 22.8227 16.0044V9.30204C22.8227 7.59096 21.4277 6.20117 19.7102 6.20117C17.9927 6.20117 16.5977 7.59096 16.5977 9.30204V16.0044C16.5977 16.7142 17.1752 17.2896 17.8877 17.2896Z",
    fill: "url(#paint3_linear_2881_52775)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M17.8877 17.2896H21.5327C22.2452 17.2896 22.8227 16.7142 22.8227 16.0044V9.30204C22.8227 7.59096 21.4277 6.20117 19.7102 6.20117C17.9927 6.20117 16.5977 7.59096 16.5977 9.30204V16.0044C16.5977 16.7142 17.1752 17.2896 17.8877 17.2896Z",
    fill: "url(#paint4_linear_2881_52775)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M29.5215 11.9479L27.909 10.3414C27.3765 9.81089 27.2865 8.94414 27.7665 8.36132C28.3215 7.69631 29.3115 7.65896 29.904 8.25671L30.039 8.39121C30.1665 8.51823 30.369 8.51823 30.4965 8.39121L30.5865 8.30155C31.119 7.77103 31.989 7.68137 32.574 8.15958C33.2415 8.7125 33.279 9.69881 32.679 10.2891L31.029 11.9329C30.609 12.3514 29.934 12.3514 29.514 11.9329L29.5215 11.9479Z",
    fill: "url(#paint5_linear_2881_52775)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M26.1617 5.02112L25.2692 4.13195C24.9692 3.83307 24.9242 3.35487 25.1942 3.03357C25.5017 2.66744 26.0492 2.64503 26.3867 2.9738L26.4617 3.04852C26.5292 3.11576 26.6492 3.11576 26.7167 3.04852L26.7692 2.99621C27.0692 2.69733 27.5492 2.6525 27.8717 2.92149C28.2392 3.22784 28.2617 3.7733 27.9317 4.10954L27.0167 5.02112C26.7842 5.25275 26.4092 5.25275 26.1767 5.02112H26.1617Z",
    fill: "url(#paint6_linear_2881_52775)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M35.7516 7.83752L34.8591 6.94836C34.5591 6.64948 34.5141 6.17127 34.7841 5.84998C35.0916 5.48385 35.6391 5.46144 35.9766 5.7902L36.0516 5.86492C36.1191 5.93217 36.2391 5.93217 36.3066 5.86492L36.3591 5.81262C36.6591 5.51374 37.1391 5.46891 37.4616 5.7379C37.8291 6.04425 37.8516 6.5897 37.5216 6.92594L36.6066 7.83752C36.3741 8.06916 35.9991 8.06916 35.7666 7.83752H35.7516Z",
    fill: "url(#paint7_linear_2881_52775)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M36.7487 13.3966L36.2987 12.9483C36.1487 12.7989 36.1262 12.5598 36.2612 12.4029C36.4112 12.2161 36.6887 12.2086 36.8537 12.373L36.8912 12.4103C36.8912 12.4103 36.9812 12.4477 37.0187 12.4103L37.0412 12.3879C37.1912 12.2385 37.4312 12.2161 37.5887 12.3506C37.7762 12.5 37.7837 12.7765 37.6187 12.9409L37.1612 13.3966C37.0487 13.5087 36.8537 13.5087 36.7412 13.3966H36.7487Z",
    fill: "url(#paint8_linear_2881_52775)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M31.7969 38.8606C37.4069 35.5057 41.3069 29.6103 41.9069 22.7734H31.7969V38.8606Z",
    fill: "url(#paint9_linear_2881_52775)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M29.0388 19.8451V21.2274C29.0388 22.1091 29.7588 22.8264 30.6438 22.8264H41.9088C41.9688 22.1988 41.9988 21.5637 41.9988 20.9211C41.9988 20.017 41.9312 19.1278 41.8187 18.2461H30.6362C29.7512 18.2461 29.0312 18.9634 29.0312 19.8451H29.0388Z",
    fill: "url(#paint10_linear_2881_52775)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M26.6016 19.1281C26.6016 19.1281 28.4841 18.5678 28.8066 18.381C29.1291 18.1942 29.5791 21.3772 27.3366 21.706",
    fill: "#F9AA8F"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M28.542 14.234H25.7595C25.422 14.234 25.1445 14.5105 25.1445 14.8467V17.2602C25.1445 18.1195 25.6995 18.8517 26.4645 19.1357C26.7045 19.2253 26.862 19.4495 26.862 19.711V21.4819C26.862 21.7733 26.622 22.0049 26.3295 22.0049C26.1645 22.0049 26.0295 22.1394 26.0295 22.3038C26.0295 22.5728 26.247 22.7895 26.517 22.7895H27.7695C28.047 22.7895 28.272 22.5578 28.257 22.2739C28.2495 22.117 28.1145 21.9974 27.957 21.9974C27.6645 21.9974 27.432 21.7658 27.432 21.4744V19.7035C27.432 19.4495 27.5895 19.2178 27.8295 19.1282C28.5945 18.8442 29.1495 18.112 29.1495 17.2527V14.8393C29.1495 14.503 28.872 14.2266 28.5345 14.2266L28.542 14.234Z",
    fill: "url(#paint11_linear_2881_52775)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M28.617 16.5961C27.342 16.8352 26.142 16.9398 25.1445 16.9174V17.2611C25.1445 18.1204 25.6995 18.8527 26.4645 19.1366C26.7045 19.2263 26.862 19.4504 26.862 19.7119V21.4828C26.862 21.7742 26.622 22.0058 26.3295 22.0058C26.1645 22.0058 26.0295 22.1403 26.0295 22.3047C26.0295 22.5737 26.247 22.7904 26.517 22.7904H27.7695C28.047 22.7904 28.272 22.5588 28.257 22.2748C28.2495 22.1179 28.1145 21.9984 27.957 21.9984C27.6645 21.9984 27.432 21.7667 27.432 21.4753V19.7045C27.432 19.4504 27.5895 19.2188 27.8295 19.1291C28.5945 18.8452 29.1495 18.1129 29.1495 17.2536V16.4766C28.9695 16.5139 28.797 16.5513 28.6095 16.5812L28.617 16.5961Z",
    fill: "url(#paint12_linear_2881_52775)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M10.5736 16.2734C10.5736 16.2734 13.6786 24.7317 18.9661 25.449C23.6086 26.0767 25.1236 21.6159 25.4236 20.525C25.4536 20.4129 25.4761 20.2934 25.4986 20.1738C25.5586 19.8226 25.8361 18.7616 26.8186 18.5449C27.9961 18.2909 28.4386 18.9036 27.8836 19.053C27.7336 19.0978 27.5911 19.1427 27.4711 19.1875C27.1486 19.3071 26.9386 19.6134 26.9461 19.9571C26.9611 20.5624 26.9761 21.4739 26.8711 21.713C26.7136 22.0717 24.8461 26.4577 21.8911 27.87C16.4161 30.4851 10.0336 24.8662 8.49609 22.7591",
    fill: "#F9AA8F"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    opacity: 0.49
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M15.7337 26.6084C16.1087 25.8238 13.1013 24.4265 13.8888 23.8437C14.3613 23.4925 15.4712 23.9558 16.2962 24.3742C14.3762 23.0816 12.8913 20.8998 11.9163 19.1289L9.53125 23.9334C10.3487 24.7553 11.4812 25.7117 12.7937 26.5411C12.8762 26.5859 12.9662 26.6382 13.0412 26.698C13.3562 26.8848 13.6712 27.0641 14.0013 27.236C14.9913 27.6395 15.4262 27.2211 15.7187 26.6084H15.7337Z",
    fill: "url(#paint13_linear_2881_52775)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M28.4819 36.3725C22.1294 36.2903 12.7544 36.3725 12.7544 36.3725L11.5469 39.6078C14.3894 41.035 17.5994 41.8494 20.9969 41.8494C24.3944 41.8494 27.3794 41.1022 30.1394 39.7647C30.5144 37.7697 30.1619 36.4024 28.4819 36.3799V36.3725Z",
    fill: "url(#paint14_linear_2881_52775)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M24.5072 30.1272C21.5822 29.8507 14.6522 35.4248 11.9147 30.6876L3.30469 31.6889C3.33469 31.8906 3.34969 32.0923 3.37219 32.2941C6.67969 37.3676 12.1247 40.9167 18.4397 41.6789C20.5097 40.4759 22.1372 39.0712 23.2022 38.0101C24.2597 36.9641 25.6847 36.3663 27.1697 36.3663H28.4747C28.4747 36.3663 26.8997 30.3514 24.4997 30.1197L24.5072 30.1272Z",
    fill: "#0D3D61"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M3.35719 33.6617C3.13219 36.5533 3.61219 40.8721 10.0847 41.8286C15.9047 42.6878 20.9672 40.237 23.2097 38.0179C24.2672 36.9718 25.6922 36.374 27.1772 36.374H28.4822C28.4822 36.374 27.9647 34.3939 27.0647 32.6679C27.0797 32.6978 27.8897 34.6181 24.8672 34.7601C21.8222 34.902 21.6872 38.1897 16.9097 37.6741C12.1322 37.166 11.9147 30.6953 11.9147 30.6953L3.30469 31.6966C3.49969 33.1461 3.46219 32.2047 3.34969 33.6692L3.35719 33.6617Z",
    fill: "url(#paint15_linear_2881_52775)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M9.15784 10.7212C9.15784 10.7212 8.07034 14.8457 12.4053 17.0649C12.4053 17.0649 6.96034 15.1745 4.03534 17.0649C1.11034 18.9553 5.06284 10.7212 5.06284 10.7212L5.47534 8.67383",
    fill: "#F9AA8F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M12.3944 17.059C12.3944 17.059 14.2619 18.0304 13.2269 20.0254C12.1919 22.0204 11.8319 21.4077 11.1644 23.9631C10.4969 26.5186 11.9969 30.8598 11.9969 30.8598C11.9969 30.8598 7.51937 33.3778 3.31187 31.6892C3.31187 31.6892 2.13437 21.5123 3.51437 17.343C4.30187 14.9744 7.06187 15.206 9.29687 15.8486C10.9994 16.3343 12.3944 17.059 12.3944 17.059Z",
    fill: "#7A86DD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M3.31266 31.689C7.52016 33.3777 11.9227 30.6878 11.9227 30.6878C11.9227 30.6878 10.4977 26.5184 11.1652 23.963C11.6977 21.9306 12.0277 21.9007 12.6652 20.9742C12.6652 20.9742 9.77766 22.3042 9.23016 20.9742C8.68266 19.6442 7.73766 16.7227 7.73766 16.7227L2.84766 24.7625C2.92266 28.3789 3.30516 31.6816 3.30516 31.6816L3.31266 31.689Z",
    fill: "url(#paint16_linear_2881_52775)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M6.61437 12.8965C6.61437 12.8965 7.96437 13.7632 8.18937 14.6076C8.41437 15.4519 9.17937 15.8106 9.47187 15.9002C9.76437 15.9899 9.06687 16.7296 9.06687 16.7296L6.60688 15.9899L5.79688 14.8392",
    fill: "#7A86DD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M3.06042 16.1918C3.06042 16.1918 3.18042 17.0511 3.16542 17.1631C2.96292 18.6949 0.922918 30.7248 7.17042 33.0187C13.8604 35.477 20.4004 31.2628 20.4004 31.2628L21.9079 30.6874C21.9079 30.6874 20.7079 29.1258 19.2079 29.746C17.7004 30.3587 18.6604 30.9041 16.4029 31.076C14.1454 31.2478 6.23292 34.3636 7.21542 23.2154C7.89042 15.5791 7.76292 13.9651 5.94792 13.8979C4.13292 13.8306 3.07542 16.1993 3.07542 16.1993L3.06042 16.1918Z",
    fill: "#F9AA8F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M7.16261 33.0184C8.03261 33.3397 8.89511 33.5414 9.74261 33.661C3.24011 32.4879 2.65511 20.5178 4.92011 19.1131C7.28261 17.6485 7.38761 14.8167 7.38761 14.8167C7.08011 14.1591 6.59261 13.92 5.93261 13.8976C5.70761 13.8901 5.49011 13.92 5.28761 13.9798L4.21511 14.6075C3.46511 15.2874 3.05261 16.2065 3.05261 16.2065C3.05261 16.2065 3.17261 17.0657 3.15761 17.1778C2.95511 18.7096 0.915106 30.7395 7.16261 33.0334V33.0184Z",
    fill: "url(#paint17_linear_2881_52775)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M11.9398 1.90444L12.8398 6.16346C12.8773 6.34279 12.8173 6.52212 12.6823 6.64167C12.5248 6.78364 12.4273 6.97044 12.4048 7.17965C12.3523 7.755 12.1273 8.92063 11.2123 8.85338C10.0048 8.76371 9.27725 9.66782 9.15725 10.7214L5.31725 9.87704C5.31725 9.87704 5.04725 3.98165 7.52225 2.32287C9.99725 0.664087 11.9398 1.90444 11.9398 1.90444Z",
    fill: "#F9AA8F"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    opacity: 0.49
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M12.3964 7.18074C12.4189 6.97153 12.5164 6.77726 12.6739 6.64276C12.7639 6.56057 12.8239 6.44849 12.8389 6.32894C12.4114 6.56804 12.4714 6.25422 12.2989 5.4323C12.1264 4.61038 12.0214 4.35633 12.1639 4.28909C12.2314 4.2592 12.3214 4.16953 12.4039 4.08734L12.1789 3.00391C10.8889 3.63155 7.56641 5.20814 7.56641 5.20814L8.42891 10.5506H8.45891C8.51141 10.3414 8.69891 9.72869 9.15641 9.24301C9.57641 8.80216 10.6039 8.79469 11.1214 8.81711C10.4614 8.72744 9.99641 8.34637 9.86141 7.30029C9.70391 6.10478 10.9189 5.23803 11.6089 5.23803C12.2989 5.23803 12.3889 7.38249 12.3889 7.38996C12.3964 7.31524 12.4114 7.24052 12.4114 7.17327L12.3964 7.18074Z",
    fill: "url(#paint18_linear_2881_52775)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M12.9736 1.73325C13.2886 2.0396 13.3111 2.54023 13.0186 2.87647C12.4711 3.49664 11.4886 4.43064 10.3261 4.6548C8.24111 5.04334 9.88361 13.0234 4.85111 16.6548C-0.18139 20.2862 -1.46389 14.5029 1.76861 11.6411C5.00111 8.77933 2.47361 0.642344 7.72361 0.0520571C10.4611 -0.261766 12.1861 0.971111 12.9736 1.73325Z",
    fill: "#594C43"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    opacity: 0.49
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M5.80392 5.55202C6.03642 4.75999 6.47142 3.99038 5.20392 3.5047C4.55892 3.25813 4.57392 2.73509 4.73892 2.2793C3.47892 5.05887 4.03392 9.6392 1.77642 11.6417C-1.45608 14.5035 -0.173577 20.2868 4.85892 16.6554C9.89142 13.024 8.24892 5.04393 10.3339 4.65539C10.4164 4.64044 10.4989 4.61803 10.5814 4.59561C8.88642 4.91691 5.57892 6.35153 5.81142 5.5595L5.80392 5.55202Z",
    fill: "url(#paint19_linear_2881_52775)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M16.5664 32.973C18.8764 32.2332 20.3914 31.2619 20.3914 31.2619L21.8989 30.6865C21.8989 30.6865 21.3739 30.0066 20.5864 29.7227C21.0814 30.0066 20.6014 30.5969 19.9189 30.3951C19.2364 30.1934 18.8914 30.7687 18.3439 31.2171C18.0364 31.4636 17.9239 32.3229 16.5739 32.9804L16.5664 32.973Z",
    fill: "url(#paint20_linear_2881_52775)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2881_52775",
    x1: 21,
    y1: 69.6762,
    x2: 21,
    y2: 3.8406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3DB6D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3D6FD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#252784"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2881_52775",
    x1: 11.6867,
    y1: 15.3992,
    x2: 11.6867,
    y2: -0.351755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1EFE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#97EFE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3CCBE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2881_52775",
    x1: 11.6867,
    y1: 21.8998,
    x2: 11.6867,
    y2: -23.0591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3DB6D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3D6FD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#252784"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2881_52775",
    x1: 19.7102,
    y1: 15.3992,
    x2: 19.7102,
    y2: -0.351755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1EFE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#97EFE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3CCBE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2881_52775",
    x1: 19.7102,
    y1: 21.8998,
    x2: 19.7102,
    y2: -23.0591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3DB6D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3D6FD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#252784"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2881_52775",
    x1: 30.2865,
    y1: 23.776,
    x2: 30.2865,
    y2: -18.874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7D63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF5763"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B3044"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2881_52775",
    x1: 26.5817,
    y1: 11.5965,
    x2: 26.5817,
    y2: -12.0972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7D63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF5763"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B3044"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2881_52775",
    x1: 36.1716,
    y1: 14.4129,
    x2: 36.1716,
    y2: -9.28078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7D63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF5763"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B3044"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2881_52775",
    x1: 36.9587,
    y1: 16.6843,
    x2: 36.9587,
    y2: 4.83375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7D63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF5763"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B3044"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2881_52775",
    x1: 36.8519,
    y1: 33.8021,
    x2: 36.8519,
    y2: 15.9739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3DB6D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3D6FD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#252784"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2881_52775",
    x1: 35.5187,
    y1: 31.5238,
    x2: 35.5187,
    y2: 7.83763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3DB6D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3D6FD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#252784"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2881_52775",
    x1: 27.1545,
    y1: 25.853,
    x2: 27.1545,
    y2: 7.92768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#CDDFEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2881_52775",
    x1: 27.1545,
    y1: 16.2225,
    x2: 27.1545,
    y2: 22.8053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#232262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2881_52775",
    x1: 20.1587,
    y1: 25.0392,
    x2: 7.63957,
    y2: 21.8112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F78E6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9AA8F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2881_52775",
    x1: 21.4244,
    y1: 40.5792,
    x2: 19.9869,
    y2: 35.4954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D3D61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#053559"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2881_52775",
    x1: 31.6172,
    y1: 30.8746,
    x2: -0.2796,
    y2: 39.3547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D3D61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#053559"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2881_52775",
    x1: 2.85516,
    y1: 24.486,
    x2: 12.6652,
    y2: 24.486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7164CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A86DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2881_52775",
    x1: 9.0601,
    y1: 24.7469,
    x2: -4.05692,
    y2: 17.4875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F78E6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9AA8F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2881_52775",
    x1: 11.6164,
    y1: 9.09357,
    x2: 8.24554,
    y2: 3.14997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F78E6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9AA8F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2881_52775",
    x1: -0.00107705,
    y1: 10.0502,
    x2: 10.5739,
    y2: 10.0502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#594C43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#473325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2881_52775",
    x1: 19.5514,
    y1: 26.1436,
    x2: 19.0229,
    y2: 35.4763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F78E6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9AA8F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2881_52775"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProductHostingMeet);
export default __webpack_public_path__ + "static/media/icon_product_hosting_meet.47ec7a78d3a4434cee57af2a1ebb7000.svg";
export { ForwardRef as ReactComponent };